<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label v-show="label" class="control-label">
      {{ label }}
      <span class="text-danger" v-if="requiredMark">*</span>
    </label>
    <textarea
      class="form-control"
      :value="value"
      :name="name"
      :id="id"
      :rows="rows || 4"
      v-bind="$attrs"
      @input="updateValue"
    ></textarea>
    <small class="text-danger" v-if="error">
      {{ error }}
    </small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'error',
    'label',
    'help',
    'id',
    'name',
    'rows',
    'requiredMark'
  ],
  emits: ['update:modelValue'],
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
